import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { GraduationCapIcon, MessageCircleIcon, VideoIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-brand-bg pt-20 md:pt-28 pb-8 md:pb-10 px-6" data-id="element-148">
      <div className="max-w-5xl mx-auto text-center" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-150">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green uppercase tracking-wide" data-id="element-151">
            Generá ingresos extra YA!
          </h1>

          <p className="mt-6 text-xl md:text-2xl text-brand-dark/70 leading-relaxed max-w-2xl mx-auto" data-id="element-152">
            Descubrí cuánto facturé en los últimos meses con
            <span className="font-semibold text-brand-green" data-id="element-153">
              {' '}
              1 solo producto{' '}
            </span>
            vendiendo por internet y como podés hacerlo vos
          </p>

          <p className="mt-3 text-lg md:text-xl text-brand-dark/80 font-medium max-w-2xl mx-auto" data-id="element-154">
            Te doy el{' '}
            <span className="font-bold text-brand-green" data-id="element-155">VERDADERO</span> paso a
            paso para copiar y pegar.
          </p>
        </motion.div>

        <motion.div className="mt-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-156">
          <p className="text-lg font-semibold text-brand-green mb-4 uppercase tracking-wider" data-id="element-157">
            Mirá el video 👇
          </p>

          <div className="relative w-full mx-auto rounded-2xl bg-brand-card border border-white/10" style={{
          paddingBottom: '65%'
        }} data-id="element-158">
            <iframe src="https://fast.wistia.net/embed/iframe/9dsb5tsk42?seo=true&videoFoam=true" title="Video de presentación" allow="autoplay; fullscreen" allowFullScreen className="absolute top-0 left-0 w-full h-full rounded-2xl" style={{
            border: 'none'
          }} data-id="element-159" />
          </div>

          {/* CTA Button and Feature Cards */}
          <div className="mt-10 flex flex-col items-center" data-id="element-160">
            <a href="https://www.emprende-digital.com/cart/51742249156888:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-brand-green hover:bg-brand-green-hover text-brand-bg font-bold text-xl px-16 py-5 rounded-full transition-all duration-300 hover:scale-105 shadow-[0_0_40px_rgba(20,184,166,0.4)] hover:shadow-[0_0_60px_rgba(20,184,166,0.6)]" data-id="element-161">
              🔥 Acceder Ahora
            </a>

            <p className="mt-5 text-brand-dark/70 text-base md:text-lg font-medium" data-id="element-162">
              ⚡ Acceso Inmediato + De 0 a Escalado en Meta
            </p>

            {/* Feature Cards */}
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 w-full max-w-5xl" data-id="element-163">
              <div className="bg-brand-card border border-white/10 rounded-2xl p-6 text-left" data-id="element-164">
                <div className="flex items-start gap-3 mb-3" data-id="element-165">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-166">
                    <GraduationCapIcon className="w-5 h-5 text-brand-green" data-id="element-167" />
                  </div>
                  <div data-id="element-168">
                    <h3 className="text-white font-bold text-base" data-id="element-169">
                      Alumnos con resultados{' '}
                      <span className="text-brand-green" data-id="element-170">REALES</span>
                    </h3>
                  </div>
                </div>
                <p className="text-brand-dark/60 text-sm leading-relaxed" data-id="element-171">
                  Casos comprobados y testimonios verificables.
                </p>
              </div>

              <div className="bg-brand-card border border-white/10 rounded-2xl p-6 text-left" data-id="element-172">
                <div className="flex items-start gap-3 mb-3" data-id="element-173">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-174">
                    <MessageCircleIcon className="w-5 h-5 text-brand-green" data-id="element-175" />
                  </div>
                  <div data-id="element-176">
                    <h3 className="text-white font-bold text-base" data-id="element-177">
                      Comunidad VIP en WhatsApp
                    </h3>
                  </div>
                </div>
                <p className="text-brand-dark/60 text-sm leading-relaxed" data-id="element-178">
                  Soporte cercano y respuesta rápida 24/7.
                </p>
              </div>

              <div className="bg-brand-card border border-white/10 rounded-2xl p-6 text-left" data-id="element-179">
                <div className="flex items-start gap-3 mb-3" data-id="element-180">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-181">
                    <VideoIcon className="w-5 h-5 text-brand-green" data-id="element-182" />
                  </div>
                  <div data-id="element-183">
                    <h3 className="text-white font-bold text-base" data-id="element-184">
                      Mentorías grupales semanales{' '}
                      <span className="text-brand-green" data-id="element-185">EN VIVO</span>
                    </h3>
                  </div>
                </div>
                <p className="text-brand-dark/60 text-sm leading-relaxed" data-id="element-186">
                  Correcciones, estrategia y dudas resueltas en directo.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}